/**
 * Csv Schema of CargaKarcher
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaKarcher} from '@/model/resource/CargaKarcher'

/* TODO: review generated schema */
export class CsvCargaKarcherSchema extends Schema {
  readonly name = 'CsvCargaKarcher'

  readonly fieldSet: FieldSet<CargaKarcher> = {
    idCargaInfoPk: schema => schema.model.idCargaInfoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    nomeArquivo: schema => schema.model.nomeArquivo,
    dataInicioDownload: schema =>
      Helper.datetime(schema.model.dataInicioDownload),
  }
}
